<template>
  <div class="">
    <div class="">
      <ValidationObserver v-slot="{ handleSubmit }">
        <CForm @submit.prevent="handleSubmit(onSubmit)">
          <CCard>
            <div>
              <CCardHeader class="grey-header">
                <CRow class="flex-flow-column">
                  <CCol>
                    <strong
                      >{{
                        selectedTax
                          ? isHotelTax
                            ? $t("cHotelTaxSetup.updateTitle")
                            : $t("cHotelTaxSetup.updateCountry")
                          : isCountryTax
                          ? $t("cHotelTaxSetup.countryTitle")
                          : $t("cHotelTaxSetup.createTitle")
                      }}
                    </strong>
                  </CCol>

                  <p class="desc">
                    {{
                      isCountryTax
                        ? $t("cHotelTaxSetup.countryDesc")
                        : $t("cHotelTaxSetup.titleDesc")
                    }}
                  </p>
                </CRow>
              </CCardHeader>
              <cPopupLoader v-if="isLoading" />

              <CCardBody v-else-if="hotelTax">
                <section class="card-body">
                  <CRow v-if="selectedTax">
                    <label>
                      {{ $t("cHotelTaxSetup.status") }}
                    </label>
                    <cStatusButton
                      class="generate-ex-btn label-margin-unset"
                      :isConfirm="true"
                      :buttonDesc="$t('cHotelTaxSetup.statusDesc')"
                      :defaultStatus.sync="selectedTax.isactive"
                      @change="onStatusChange"
                      :label="{
                        checked: $t('cHotelTaxSetup.active'),
                        unchecked: $t('cHotelTaxSetup.inactive'),
                      }"
                    >
                    </cStatusButton>
                  </CRow>

                  <CRow>
                    <div class="subtitile-details">
                      <CCol class="d-flex">
                        <p class="v-center field-wrapper required-field">
                          <label>{{ $t("cHotelTaxSetup.country") }}</label>
                        </p>
                      </CCol>

                      <div class="col">
                        <cDropDown
                          :ctrlName="'value'"
                          :ctrlCode="'countrycode'"
                          :isShowCode="true"
                          :isMultiple="false"
                          :isSearchable="true"
                          :url="getCountryServiceURL()"
                          :rules="'required'"
                          :placeholder="$t('cHotelTaxSetup.countryPh')"
                        
                        
                          v-on:input="onCountryChange"
                          :defaultCountryCode="
                            isCountryTax && !selectedTax
                              ? null
                              : selectedTax && selectedTax.country
                              ? selectedTax.country
                              : hotelObj
                              ? hotelObj.countryCode
                              : null
                          "
                        />
                      </div>
                    </div>
                  </CRow>
                  <br />
                  <br />

                  <CRow v-if="!isHotelTax">
                    <div class="subtitile-details">
                      <CCol class=" d-flex">
                        <p class="v-center">
                          <label>{{ $t("cHotelTaxSetup.hotel") }}</label>
                        </p>
                      </CCol>

                      <div class="col">
                        <ValidationProvider
                          :rules="'required'"
                          v-slot="{ errors }"
                        >
                          <multiselect
                            v-if="lsHotels && lsHotels.length != null"
                            v-model="hotelTax.hotelId"
                            label="hotelName"
                            :allow-empty="true"
                            :options="lsHotels"
                            :track-by="'hotelid'"
                            :showLabels="false"
                            :placeholder="$t('cHotelTaxSetup.hotelPl')"
                            @input="onHotelChange"
                            :multiple.sync="isMultipleHotel"
                          >
                            <template #noOptions>
                              {{
                                !hotelTax.country
                                  ? $t("cHotelTaxSetup.selCountry ")
                                  : $t("cHotelTaxSetup.listEmpty")
                              }}
                            </template>
                            <template #noResult>
                              <strong>
                                {{ $t("cHotelTaxSetup.listEmpty") }}</strong
                              >
                            </template>
                          </multiselect>
                          <div
                            v-if="errors && errors[0]"
                            class="invalid-feedback icon"
                          >
                            <span>{{ errors[0] }}</span>
                          </div>
                        </ValidationProvider>
                      </div>
                    </div>
                  </CRow>
                  <CRow>
                    <div>
                      <span>
                        <strong>
                          {{ $t("cHotelTaxSetup.appTypes") }}
                          <br />
                        </strong>
                      </span>
                    </div>
                  </CRow>

                  <CRow>
                    <cTextInputComponent
                      :name="$t('cHotelTaxSetup.taxCode')"
                      :upperCase="true"
                      :label="$t('cHotelTaxSetup.taxCode')"
                      :placeholder="$t('cHotelTaxSetup.taxCodePh')"
                      :rules="
                        'required|max:5|minimum:2|alpha_num|noInitialSpace'
                      "
                      v-model="hotelTax.taxCode"
                    >
                    </cTextInputComponent>
                  </CRow>

                  <CRow>
                    <cTextInputComponent
                      :label="$t('cHotelTaxSetup.desc')"
                      :placeholder="$t('cHotelTaxSetup.descPh')"
                      v-model="hotelTax.taxDesc"
                      :rules="'required|max:150|noInitialSpace'"
                    >
                    </cTextInputComponent>
                  </CRow>

                  <CRow>
                    <ValidationProvider
                      v-slot="{ errors }"
                      :rules="'required'"
                      tag="div"
                    >
                      <div>
                        <span>
                          {{ $t("cHotelTaxSetup.taxType") }}
                        </span>
                      </div>
                      <multiselect
                        v-if="lsTaxTypes && lsTaxTypes.length"
                        :allow-empty="false"
                        :showLabels="false"
                        :clearOnSelect="false"
                        :options="lsTaxTypes"
                        v-model="hotelTax.taxType"
                        :multiple="false"
                        :group-select="false"
                        :placeholder="$t('cHotelTaxSetup.taxTypePh')"
                        track-by="value"
                        label="name"
                        class="mt-auto"
                        :searchable="true"
                      >
                        <span slot="noResult"
                          ><strong>{{
                            $t("noMatchFound.noMatchFound")
                          }}</strong></span
                        >
                      </multiselect>
                      <div
                        v-if="errors && errors[0]"
                        class="invalid-feedback icon"
                      >
                        {{ errors[0] }}
                      </div>
                    </ValidationProvider>
                  </CRow>

                  <CRow>
                   
                      <span>
                        {{ $t("cHotelTaxSetup.roomType") }}
                      </span>

                      <CRow v-if="roomTypesRes && roomTypesRes.length">
                        <CCol>
                          <cTextInputComponent
                            :placeholder="$t('cHotelTaxSetup.searchPh')"
                            @input="onRoomTypeSearch"
                          ></cTextInputComponent>
                        </CCol>
                        <CCol
                          v-if="lsAllRoomTypes && lsAllRoomTypes.length"
                         
                        >
                          <label class="py-2">
                            <input
                              type="checkbox"
                              v-model="isSelectAll"
                              @change="selectAllRoomType(isSelectAll)"
                            />

                            {{ $t("cBedTypes.selectAll") }}
                          </label>

                        </CCol>
                      </CRow>
                       </CRow>
                        <CCol
                        
                        >
                          <span
                            
                            class="activeText"
                          >
                           
                          </span>
                        </CCol>
                     
                     
                     
                 
                

                  <!-- <CRow v-if="lsGuestTypes && lsGuestTypes.length">
                      <CCol>
                        <span>
                          {{ $t("cHotelTaxSetup.guestType") }}
                        </span>
                      </CCol>
                      <br />
                      <br /> -->

                  <div class="row" v-if="lsAllRoomTypes && lsAllRoomTypes.length">
                   
                           <div class="col-md-4"
                          v-for="(roomType, index) in lsAllRoomTypes"
                          :key="index + 'search'"
                        >
                         
                        
                              <label  v-if="showMoreTypes ? index < 6 : true"  class="p-3">
                                <input
                                 class="mr-2"
                                  @input="selectRoomType(roomType)"
                                  type="checkbox"
                                  :checked="
                                    hotelTax.roomTypes.includes(roomType)
                                  "
                                />
                                {{ roomType }}
                              </label>
                            
                          
                        </div>
                         <CLink  @click="showMoreTypes = !showMoreTypes"  v-if="lsAllRoomTypes && lsAllRoomTypes.length > 6" class="py-2 px-4">
                              {{
                              !showMoreTypes
                                ? $t("cHotelTaxSetup.showLess")
                                : $t("cHotelTaxSetup.showMore")
                            }}
                         </CLink>
                      
                    <ValidationProvider :rules="'required'" v-slot="{ errors }">
                      <CRow v-model="hotelTax.roomTypes"></CRow>
                      <div
                        v-if="errors && errors[0]"
                        class="invalid-feedback icon"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </ValidationProvider>
                  </div>
                   <div class="col-md-4"  v-if="lsAllRoomTypes.length == 0">
                        <span slot="noResult"
                          ><strong>{{
                            $t("noMatchFound.noMatchFound")
                          }}</strong></span
                        >
                      </div>
        
                </section>
                <section>
                  <!-- <CRow>
                      <CCol>
                        <div class="">
                          {{ $t("cHotelTaxSetup.checkIn") }}
                        </div>
                      </CCol> -->

                  <!-- <span v-else>
                          {{ $t("cAllHotelTax.noResult") }}
                        </span>
                      </CCol>
                    </CRow>
                  </div>
                </CRow> -->

                  <!-- <CRow>
                      <div v-if="hotelObj" class="subtitile-details">
                        <CCol class="d-flex">
                          <p class="v-center field-wrapper required-field">
                            <label>{{ $t("cHotelTaxSetup.country") }}</label>
                          </p>
                        </CCol>
                        <div class="col">
                          <cDropDown
                            :ctrlName="'value'"
                            :ctrlCode="'countrycode'"
                            :isShowCode="true"
                            :isMultiple="false"
                            :isSearchable="true"
                            :url="getCountryServiceURL()"
                            :rules="'required'"
                            :placeholder="$t('cHotelTaxSetup.countryPh')"
                            :resultEmpty="$t('passInfo.countryResultEmpty')"
                            v-model="hotelTax.country"
                            :defaultCountryCode="
                              selectedTax && selectedTax.country
                                ? selectedTax.country
                                : hotelObj.countryCode
                            "
                            v-on:input="onCountryChange" -->
                  <!-- <CRow v-if="lsGuestTypes && lsGuestTypes.length">
                  <CCol>
                    <span>
                      {{ $t("cHotelTaxSetup.guestType") }}
                    </span>
                  </CCol>
                  <br />
                  <br />

                  <CCol>
                    <ul
                      style="{display:inline}"
                      v-for="(guestType, index) in lsGuestTypes"
                      :key="index + 'gt'"
                    >
                      <li>
                        <label>
                          <input
                            type="checkbox"
                            :checked="
                              hotelTax.paxType.includes(guestType.value)
                            "
                            @change="selectGuest(guestType)"
                          />

                          {{ guestType.name }}
                        </label>
                      </li>
                    </ul>
                  </CCol>
                    <ValidationProvider :rules="'required'" v-slot="{ errors }">
        <CRow v-model="hotelTax.paxType"></CRow>
        <div v-if="errors && errors[0]" class="invalid-feedback icon">
          <span>{{ errors[0] }}</span>
        </div>
      </ValidationProvider>
                </CRow> -->
                </section>
                <section class="card-body">
                  <CRow>
                    <CCol>
                      <div class="">
                        {{ $t("cHotelTaxSetup.checkIn") }}
                      </div>
                    </CCol>

                    <CCol>
                      <div class="ext-date-wrapper box-shadow left">
                        <v-md-date-range-picker
                          :ref="''"
                          :autoApply="true"
                          :showYearSelect="true"
                          :allowPastPresets="false"
                          :disableBefore="new Date().toString()"
                          @change="onChangeDate"
                        >
                          <template slot="input">
                            <datePickerInput
                              :fromDate="
                                hotelTax.checkInDateFrom
                                  ? hotelTax.checkInDateFrom
                                  : null
                              "
                              :toDate="
                                hotelTax.checkInDateTo
                                  ? hotelTax.checkInDateTo
                                  : null
                              "
                              :fromLabel="$t('cHotelTaxSetup.from')"
                              :toLabel="$t('cHotelTaxSetup.to')"
                            />
                          </template>
                        </v-md-date-range-picker>

                        <span
                          class="input-group-btn tooltipIconAlign d-flex ai-center right-pa-icon"
                        >
                          <img
                            src="@imgPath/img/svg/icons/help.svg"
                            alt=""
                            width="15px"
                            v-c-tooltip.hover="{
                              content:
                                
                                 $t('hotelInfo.datePickerToolTip'),
                            }"
                          />
                        </span>
                      </div>
                    </CCol>
                  </CRow>
                </section>
                <section v-if='TAX_MODE' class="card-body">
                  <div>
                    <span>
                      <div class="">
                        <strong>
                          <span>
                            {{ $t("cHotelTaxSetup.appValue") }}
                          </span>
                        </strong>
                      </div>
                    </span>
                  </div>

                  <CRow>
                    <CCol>
                      <CRow>
                        <label for="FIXED">
                          <input
                            name="taxtype"
                            type="radio"
                            id="FIXED"
                            :value="TAX_MODE.FIXED"
                            v-model="hotelTax.taxMode"
                          />
                          {{ $t("cHotelTaxSetup.fixed") }}
                        </label>
                        <span class="d-flex">
                          <!-- class="d-flex" -->
                          <cHelpTip
                            :content="$t('cHotelTaxSetup.priceUnit')"
                          ></cHelpTip>
                        </span>
                      </CRow>
                    </CCol>
                    <CCol>
                      <CRow>
                        <label for="PERCENTAGE">
                          <input
                            name="taxtype"
                            type="radio"
                            id="PERCENTAGE"
                            :value="TAX_MODE.PERC"
                            v-model="hotelTax.taxMode"
                          />
                          {{ $t("cHotelTaxSetup.perc") }}
                        </label>
                        <span class="d-flex">
                          <!-- class="d-flex" -->
                          <cHelpTip
                            :content="$t('cHotelTaxSetup.priceUnit')"
                          ></cHelpTip>
                        </span>
                      </CRow>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol>
                      <span>
                        {{ $t("cHotelTaxSetup.amount") }}
                      </span>
                    </CCol>
                    <CCol v-show=" TAX_MODE && hotelTax.taxMode == TAX_MODE.FIXED">
                      <cCurrencyDropDown
                        :selValue="hotelTax.taxCurrency"
                        :ctrlName="'code'"
                        :ctrlCode="'code'"
                        :isShowCode="true"
                        :isMultiple="false"
                        :isSearchable="true"
                        v-model="hotelTax.taxCurrency"
                        :url="getCurrencyServiceURL()"
                        :rules="'required'"
                        :defaultCurrencyCode="null"
                      />
                    </CCol>
                    <CCol>
                      <div
                        class="input-group  flex-flow-row d-flex wrapper-prepend"
                      >
                        <div
                          v-if="
                            hotelTax.taxCurrency &&
                              hotelTax.taxMode == TAX_MODE.FIXED
                          "
                          class="input-group-prepend align-curr"
                        >
                          <div></div>

                          <span class="input-group-text">{{
                            hotelTax.taxCurrency.code
                          }}</span>
                        </div>

                        <cTextInputComponent
                          :placeholder="
                            hotelTax.taxMode == TAX_MODE.PERC
                              ? $t('cHotelTaxSetup.percPh')
                              : $t('cHotelTaxSetup.amountPh')
                          "
                          :rules="
                            'required|onlynumber|validDecimal' +
                              (hotelTax.taxMode == TAX_MODE.PERC
                                ? '|max_value:100'
                                : '')
                          "
                          v-model="hotelTax.taxValue"
                        >
                        </cTextInputComponent>
                        <!-- <div class="input-group-append align-curr">
                        <div></div>

                        <span
                          v-if="hotelTax.taxMode == TAX_MODE.PERC"
                          class="input-group-text"
                          >{{ "%" }}</span
                        >
                      </div>
                    </div>
                  </CCol>
                </CRow>
              </section>
            </CCardBody>

            <CCardFooter class="d-flex justify-content-end">
              <div class="main-cta-btn">
                <CButton
                  @click="onTaxSetupFormCancel"
                  color="danger"
                  class="action-c-btn"
                >
                  <img src="@imgPath/img/svg/icons/close.svg" />
                  {{ $t("cHotelTaxSetup.cancel") }}
                </CButton>
                <CButton
                  col="12"
                  type="submit"
                  color="success removewrap"
                  class="action-c-btn"
                >
                  <img src="@imgPath/img/svg/icons/correct.svg" />
                  {{
                    selectedTax
                      ? $t("cHotelTaxSetup.update")
                      : $t("cHotelTaxSetup.add")
                  }}
                </CButton> -->
                        <div class="input-group-append align-curr">
                          <div></div>

                          <span
                            v-if="hotelTax.taxMode == TAX_MODE.PERC"
                            class="input-group-text"
                            >{{ "%" }}</span
                          >
                        </div>
                        <span class="d-flex">
                          <!-- class="d-flex" -->
                          <cHelpTip
                            :content="$t('cHotelTaxSetup.priceUnit')"
                          ></cHelpTip>
                        </span>
                      </div>
                    </CCol>
                  </CRow>
                </section>
              </CCardBody>

              <CCardFooter class="d-flex justify-content-end" v-if="!isLoading">
                <div class="main-cta-btn">
                  <!-- @click="onTaxSetupFormCancel" -->
                  <CButton
                    @click="onTaxSetupFormCancel()"
                    color="danger"
                    class="action-c-btn"
                  >
                    <img src="@imgPath/img/svg/icons/close.svg" />
                    {{ $t("cHotelTaxSetup.cancel") }}
                  </CButton>
                  <CButton
                    col="12"
                    type="submit"
                    color="success removewrap"
                    class="action-c-btn"
                  >
                    <img src="@imgPath/img/svg/icons/correct.svg" />
                    {{
                      selectedTax
                        ? $t("cHotelTaxSetup.update")
                        : $t("cHotelTaxSetup.add")
                    }}
                  </CButton>
                </div>
              </CCardFooter>
            </div>
          </CCard>
        </CForm>
      </ValidationObserver>

      <cAlertModal
        v-if="showConfirmModal"
        :show="showConfirmModal"
        :buttonList="getConfirmModalButtons()"
        :status="2"
        :isShowIcon="true"
        :desc="$t('ratePlanNew.confirmDesc')"
      >
      </cAlertModal>
      <cAlertModal
        v-if="showSuccModal"
        :show="showSuccModal"
        :buttonList="getSuccModalButtons()"
        :status="1"
        :isShowIcon="true"
        :desc="
          selectedTax
            ? $t('cHotelTaxSetup.updateDesc')
            : $t('cHotelTaxSetup.succDesc')
        "
      >
      </cAlertModal>
    </div>
  </div>
</template>

<script>
import {
  COMPONENT_NAME,
  ORDER,
  PATHNAME,
  DATE_TIME_FORMAT,
  DEFAULT_DROPDOWN_STATUS,
} from "../../../../util/constants";
import router from "../../../../router/index";
import { ValidationObserver, ValidationProvider } from "vee-validate";

import datePickerInput from "../../../../components/datePicker/datePickerInput";
import { VMdDateRangePicker } from "material-vue-date-picker";

import cCurrencyDropDown from "../../../../components/currency/cCurrencyDropDown.vue";
import { goBack, navigate } from "../../../../router";
import { addDays } from "../../../../util/date/dateFunctions";

import cHelpTip from "../../../../components/cHelpTip.vue";
import multiselect from "vue-multiselect";
import cStatusButton from "../../../../components/form/cStatusButton.vue";

import { mapGetters, mapActions } from "vuex";
import Logger from "../../../../services/logger";

import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage,
} from "../../../../util/apiValidate";
import {
  handleJWT,
  getErrorAlertValue,
  addClassToBody,
  removeClassBody,
  cloneDeep,
  OrderByList,
  GroupByList,
  showSuccessToast,
} from "../../../../util/util";
import SERVICE_URL, {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES,
} from "../../../../config/API_DATA";
import BaseConfiguration from "../../../../config/base";
//import apiGethotelTaxs from "../../../../services/apiGethotelTaxs";
import apiUpdateHotelGuestAgeSetup from "../../../../services/apiUpdateHotelGuestAgeSetup";
import cTextInputComponent from "../../../../components/form/cTextInputComponent";
import cAlertModal from "../../../../components/form/cAlertModal";
import cContentEdit from "../../../../components/hms/manage/hotelInfo/cContentEdit";
import apiGetRoomTypes from "../../../../services/apiGetRoomTypes";
import apiCreateHotelTax from "../../../../services/apiCreateHotelTax";
import apiHmsCountryTax from "../../../../services/apiHmsCountryTax";
import apiUpdateHotelTax from "../../../../services/apiUpdateHotelTax";
import cDropDown from "../../../../components/form/cDropDown";
import cPopupLoader from "../../../../components/cPopupLoader";
import apiGetAllHotels from "../../../../services/apiGetAllHotels";

export default {
  name: COMPONENT_NAME.C_HOTEL_TAX_SETUP,

  components: {
    cStatusButton,
    cDropDown,
    multiselect,
    cAlertModal,
    datePickerInput,
    VMdDateRangePicker,
    ValidationObserver,
    ValidationProvider,
    cHelpTip,

    cCurrencyDropDown,
    cTextInputComponent,
    cPopupLoader,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },

    isHotelTax: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      lsTaxTypes: [],
      lsGuestTypes: [],
      lsAllRoomTypes: [],
      roomTypesRes: [],
      showConfirmModal: false,
      showSuccModal: false,
      isSelectAll: false,
      showMoreTypes: false,
      isMultipleHotel: false,
      lsHotels: [],
      hotelTax: {
        hotelId: [],
        taxCode: null,
        taxDesc: null,
        roomTypes: [],
        paxType: [],
        checkInDateFrom: null,
        checkInDateTo: null,
        country: null,
        taxType: null,
        taxCurrency: null,
        taxValue: null,
        taxMode: "PERC",
      },
      isLoading: true,
    };
  },

  computed: {

      ...mapGetters("sCurrencyLs", {
       allCurrencyList:"GET_CURRENCY_RES",
         }),
    ...mapGetters("sHotelInfo", {
      hotelObj: "GET_HOTEL_OBJ",
    }),
    ...mapGetters("shmsManage", {
      TAX_MODE: "GET_TAX_MODE",
      TAX_TYPE: "GET_TAX_TYPE",
      GUEST_TYPE: "GET_GUEST_TYPE",
    }),

    ...mapGetters("sHotelTax", {
      selectedTax: "GET_SELECTED_TAX",
      isCountryTax: "GET_IS_COUNTRY_TAX",
      lsAllHotels: "GET_ALL_HOTELS",
    }),
  },

  methods: {
    ...mapActions("sHotelTax", {
      SET_ALL_HOTELS: "SET_ALL_HOTELS",
    }),



    onHotelChange(pHotel) {
      try {
        if (BaseConfiguration.isDebug) console.log("onHotelChange");

        let lsHotelIds = [];

        if (pHotel) {
          if (pHotel.constructor == Object) {
            lsHotelIds = [pHotel];
            this.hotelTax.hotelId = cloneDeep(lsHotelIds);
          } else {
            lsHotelIds = pHotel;
          }

          if (
            lsHotelIds.some(
              (hotel) => hotel.hotelid == DEFAULT_DROPDOWN_STATUS.ALL
            )
          ) {
            this.isMultipleHotel = false;
            this.hotelTax.hotelId = null;
            this.hotelTax.hotelId = [
              lsHotelIds.find(
                (hotel) => hotel.hotelid == DEFAULT_DROPDOWN_STATUS.ALL
              ),
            ];
          } else this.isMultipleHotel = true;
        } else throw "invalid hotel";
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_TAX_SETUP,
          "error in onHotelChange",
          err.toString(),
          "onHotelChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async getAllHotels() {
      let returnValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getAllHotels");

        let allHotelsRequest = apiGetAllHotels.buildRequest();

        if (allHotelsRequest != null) {
          let allHotelsResponse = await apiGetAllHotels.getResponse(
            allHotelsRequest
          );
          if (VALIDATE_SUCCESS_RES(allHotelsResponse)) {
            returnValue = allHotelsResponse.data.data.list;

            //            returnValue.forEach(hotel=>{

            //              hotel["country"] =
            //              this.$options.filters.hmsCountryName(hotel.countryCode);
            //               hotel["city"]=
            //              this.$options.filters.hmsCityName(hotel.cityCode);
            //              if(hotel.supplierName)
            //              hotel.supplierName=hotel.supplierName
            //              else
            //               hotel.supplierName=''
            //            })
            // this.SET_HOTEL_LS(returnValue);
          } else {
            let error = getErrorMessage(allHotelsResponse);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              getErrorAlertValue(error);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_HOTEL_TAX_SETUP,
          "error in  getALLHotels",
          err.toString(),
          "getAllHotels",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

    onStatusChange(pStatus) {
      try {
        if (BaseConfiguration.isDebug) console.log("onStatusChange");
        this.hotelTax.isActive = pStatus;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_TAX_SETUP,
          "error in onStatusChange",
          err.toString(),
          "onStatusChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    onCountryChange(pCountry) {
      try {
        if (BaseConfiguration.isDebug) console.log("onCountryChange");

        if (pCountry) {
          this.hotelTax.country = pCountry ? pCountry.countrycode : null;

          // if(this.allCurrencyList && this.allCurrencyList.length)
          // {
          //   this.hotelTax.taxCurrency =this.allCurrencyList.find(currency=> currency.countryCode== pCountry.countrycode)
          // }

          if (!this.isHotelTax && this.lsAllHotels && this.lsAllHotels.length) {
            this.lsHotels = this.lsAllHotels.filter(
              (hotel) => hotel.countryCode == pCountry.countrycode
            );
            if (this.lsHotels && this.lsHotels.length) {
              this.lsHotels.unshift({
                hotelName: DEFAULT_DROPDOWN_STATUS.ALL,
                hotelid: DEFAULT_DROPDOWN_STATUS.ALL,
              });
            }
          }
        } else {
          throw "invalid country code";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_TAX_SETUP,
          "error in onCountryChange",
          err.toString(),
          "onCountryChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    onRoomTypeSearch(pPartialRoomTypeName) {
      try {
        if (BaseConfiguration.isDebug) console.log("onRoomTypeSearch");

        if (this.roomTypesRes && this.roomTypesRes.length) {
          this.lsAllRoomTypes = this.roomTypesRes.filter((type) =>
            type
              .toString()
              .trim()
              .toLowerCase()
              .includes(
                pPartialRoomTypeName
                  .toString()
                  .trim()
                  .toLowerCase()
              )
          );
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_TAX_SETUP,
          "error in onRoomTypeSearch",
          err.toString(),
          "onRoomTypeSearch",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onTaxSetupFormSave() {
      try {
        if (BaseConfiguration.isDebug) console.log("onTaxSetupFormSave");

        this.$emit("onTaxSetupFormSave");
        //  this.toggleSuccModal();

        /*      if (
          !BaseConfiguration.manageHotelPopup ||
          (router &&
            router.currentRoute &&
            router.currentRoute.path == PATHNAME.HOTEL_TAX_NEW)
        ) {
          goBack();
        } */
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_TAX_SETUP,
          "error in onTaxSetupFormSave",
          err.toString(),
          "onTaxSetupFormSave",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onTaxSetupFormCancel() {
      try {
        if (BaseConfiguration.isDebug) console.log("onTaxSetupFormCancel");
        this.$emit("onTaxSetupFormCancel");

        /*    if (
          !BaseConfiguration.manageHotelPopup ||
          (router &&
            router.currentRoute &&
            router.currentRoute.path == PATHNAME.HOTEL_TAX_NEW)
        ) {
          goBack();
        } */
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_TAX_SETUP,
          "error in onTaxSetupFormCancel",
          err.toString(),
          "onTaxSetupFormCancel",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async onSubmit() {
      try {
        if (BaseConfiguration.isDebug) console.log("onSubmit");
        let createdRes;
        let updatedRes;
        let toastMsg;
        this.hotelTax.taxCode = this.hotelTax.taxCode
          ? this.hotelTax.taxCode.toUpperCase()
          : null;

        if (this.selectedTax) {
          updatedRes = await this.updateHotelTax();
          toastMsg =
            "The Tax " + this.hotelTax.taxCode + " was updated successfully";
        } else {
          createdRes = this.isHotelTax
            ? await this.createHotelTax()
            : await this.createCountryTax();
          toastMsg =
            "The Tax " +
            this.hotelTax.taxCode.toUpperCase() +
            " was created successfully";
        }
        if (
          (createdRes && createdRes.id) ||
          (updatedRes && updatedRes.isUpdated)
        ) {
          this.onTaxSetupFormSave();
          showSuccessToast(toastMsg);
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_TAX_SETUP,
          "error in onSubmit",
          err.toString(),
          "onSubmit",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getSuccModalButtons() {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getSuccModalButtons");

        retValue = [
          {
            name: this.$t("ratePlanNew.Ok"),
            func: this.onTaxSetupFormSave,
          },
        ];
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_TAX_SETUP,
          "error in getSuccModalButtons",
          err.toString(),
          "getSuccModalButtons",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }

      return retValue;
    },

    getConfirmModalButtons() {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getConfirmModalButtons");

        retValue = [
          {
            name: this.$t("ratePlanNew.stay"),
            func: this.toggleConfirmModal,
          },
          {
            name: this.$t("ratePlanNew.leave"),
            func: this.onTaxSetupFormCancel,
          },
        ];
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_TAX_SETUP,
          "error in getConfirmModalButtons",
          err.toString(),
          "getConfirmModalButtons",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    toggleConfirmModal() {
      try {
        if (BaseConfiguration.isDebug) console.log("toggleConfirmModal");

        //   this.showConfirmModal = !this.showConfirmModal;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_TAX_SETUP,
          "error in toggleConfirmModal",
          err.toString(),
          "toggleConfirmModal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    toggleSuccModal() {
      try {
        if (BaseConfiguration.isDebug) console.log("toggleSuccModal");

        this.showSuccModal = !this.showSuccModal;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_TAX_SETUP,
          "error in toggleSuccModal",
          err.toString(),
          "toggleSuccModal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getCountryServiceURL() {
      if (BaseConfiguration.isDebug) console.log("getCountryServiceURL");
      return SERVICE_URL.GET_COUNTRY_LIST;
    },

    selectAllRoomType(pisSelected) {
      try {
        if (BaseConfiguration.isDebug) console.log("selectAllRoomType");
        if (pisSelected) {
          for (let i = 0; i < this.lsAllRoomTypes.length; i++) {
            this.hotelTax.roomTypes.push(this.lsAllRoomTypes[i]);
          }
        } else {
          this.hotelTax.roomTypes = [];
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_TAX_SETUP,
          "error in selectAllRoomType",
          err.toString(),
          "selectAllRoomType",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    selectGuest(pGuestType) {
      try {
        if (BaseConfiguration.isDebug) console.log("selectGuest");

        if (pGuestType && this.hotelTax.paxType.includes(pGuestType.value)) {
          this.hotelTax.paxType = this.hotelTax.paxType.filter(
            (pax) => pax != pGuestType.value
          );
        } else {
          this.hotelTax.paxType.push(pGuestType.value);
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_TAX_SETUP,
          "error in selectGuest",
          err.toString(),
          "selectGuest",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async updateHotelTax() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("updateHotelTax");

        // hotel tax flow
        if (this.selectedTax && this.hotelTax) {
          let hotelId;
          if (
            this.isHotelTax &&
            this.selectedTax.taxSetupHotels &&
            this.selectedTax.taxSetupHotels[0]
          ) {
            hotelId =
              this.selectedTax.taxSetupHotels[0] &&
              this.selectedTax.taxSetupHotels[0].hotelid
                ? [this.selectedTax.taxSetupHotels[0].hotelid]
                : null;
          } // hotel country flow
          else if (
            !this.isHotelTax &&
            this.hotelTax.hotelId &&
            this.hotelTax.hotelId.length
          ) {
            hotelId = this.hotelTax.hotelId
              .map((hotel) => hotel.hotelid)
              .filter(
                (val) => val != null && val != DEFAULT_DROPDOWN_STATUS.ALL
              );
          }

          let updateHotelTaxReq = apiUpdateHotelTax.buildRequest(
            cloneDeep(this.hotelTax),
            hotelId && hotelId.length ? hotelId : null,
            this.TAX_MODE
          );

          if (updateHotelTaxReq) {
            let updateHotelTaxRes = await apiUpdateHotelTax.getResponse(
              updateHotelTaxReq
            );

            if (VALIDATE_SUCCESS_RES(updateHotelTaxRes)) {
              retValue = updateHotelTaxRes.data.data;
            } else {
              let error = getErrorMessage(updateHotelTaxRes);

              let isJwt = handleJWT(error);
              if (!isJwt) {
                getErrorAlertValue(error);
              }
            }
          }
        } else {
          throw "invalid tax  obj";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_TAX_SETUP,
          "error in updateHotelTax",
          err.toString(),
          "updateHotelTax",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    async createCountryTax() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("createCountryTax");
        if (this.hotelTax) {
          let hotelId = null;
          if (this.hotelTax.hotelId && this.hotelTax.hotelId.length) {
            hotelId = this.hotelTax.hotelId
              .map((hotel) => hotel.hotelid)
              .filter(
                (val) => val != null && val != DEFAULT_DROPDOWN_STATUS.ALL
              );
          }

          let createCountryTaxReq = apiHmsCountryTax.buildRequest(
            cloneDeep(this.hotelTax),
            hotelId,
            this.TAX_MODE
          );

          if (createCountryTaxReq) {
            let createCountryTaxRes = await apiHmsCountryTax.getResponse(
              createCountryTaxReq
            );

            if (VALIDATE_SUCCESS_RES(createCountryTaxRes)) {
              retValue = createCountryTaxRes.data.data;
            } else {
              let error = getErrorMessage(createCountryTaxRes);

              let isJwt = handleJWT(error);
              if (!isJwt) {
                getErrorAlertValue(error);
              }
            }
          }
        } else {
          throw "invalid hotel obj";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_TAX_SETUP,
          "error in createCountryTax",
          err.toString(),
          "createCountryTax",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    async createHotelTax() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("createHotelTax");
        if (this.hotelTax) {
          let hotelId = this.isCountryTax
            ? null
            : this.hotelObj
            ? this.hotelObj.hotelid
            : null;
          let createHotelTaxReq = apiCreateHotelTax.buildRequest(
            cloneDeep(this.hotelTax),
            hotelId,
            this.TAX_MODE
          );

          if (createHotelTaxReq) {
            let createHotelTaxRes = await apiCreateHotelTax.getResponse(
              createHotelTaxReq
            );

            if (VALIDATE_SUCCESS_RES(createHotelTaxRes)) {
              retValue = createHotelTaxRes.data.data;
            } else {
              let error = getErrorMessage(createHotelTaxRes);

              let isJwt = handleJWT(error);
              if (!isJwt) {
                getErrorAlertValue(error);
              }
            }
          }
        } else {
          throw "invalid hotel obj";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_TAX_SETUP,
          "error in createHotelTax",
          err.toString(),
          "createHotelTax",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    getGuestTypes() {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getGuestTypes");

        if (this.GUEST_TYPE) {
          Object.keys(this.GUEST_TYPE).forEach((key) => {
            retValue.push({
              name: this.GUEST_TYPE[key],
              value: key,
            });
          });
        } else {
          throw "hotel guest type invalid";
        }

        /*   retValue = [
          {
            name: this.$t("cHotelTaxSetup.adt"),
            value: "ADT",
          },
          {
            name: this.$t("cHotelTaxSetup.chd"),
            value: "CHD",
          },
          {
            name: this.$t("cHotelTaxSetup.inf"),
            value: "INF",
          },
        ]; */
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_TAX_SETUP,
          "error in getGuestTypes",
          err.toString(),
          "getGuestTypes",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    getTaxTypes() {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getTaxTypes");

        if (this.TAX_TYPE) {
          let taxType = cloneDeep(this.TAX_TYPE);

          Object.keys(taxType).forEach((key) => {
            retValue.push({
              name: taxType[key],
              value: key,
            });
          });
        } else {
          retValue = [];
          throw "invalid tax type obj";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_TAX_SETUP,
          "error in getTaxTypes",
          err.toString(),
          "getTaxTypes",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    selectRoomType(pRoomType) {
      try {
        if (BaseConfiguration.isDebug) console.log("selectRoomType");

        if (pRoomType && this.hotelTax.roomTypes.includes(pRoomType)) {
          this.hotelTax.roomTypes = this.hotelTax.roomTypes.filter(
            (type) => type != pRoomType
          );
        } else if (pRoomType) {
          this.hotelTax.roomTypes.push(pRoomType);
        } else {
          throw "invalid selection";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_TAX_SETUP,
          "error in selectRoomType",
          err.toString(),
          "selectRoomType",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async getRoomTypes() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getRoomTypes");

        let roomTypesReq = apiGetRoomTypes.buildRequest();

        if (roomTypesReq) {
          let roomTypesRes = await apiGetRoomTypes.getResponse(roomTypesReq);

          if (VALIDATE_SUCCESS_RES(roomTypesRes)) {
            if (roomTypesRes.data.data) retValue = roomTypesRes.data.data.list;
          } else {
            let error = getErrorMessage(roomTypesRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              getErrorAlertValue(error);
            }
          }
        } else {
          throw "invalid req";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_TAX_SETUP,
          "error in getRoomTypes",
          err.toString(),
          "getRoomTypes",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    getCurrencyServiceURL() {
      if (BaseConfiguration.isDebug) console.log("getCurrencyServiceURL");
      return SERVICE_URL.GET_CURRENCY_LIST;
    },
    setStayPeriod(photelTax) {
      try {
        if (BaseConfiguration.isDebug) console.log("setStayPeriod");

        photelTax.checkInDateFrom = this.$options.filters.formatDate(
          new Date(),
          DATE_TIME_FORMAT.API_DATE_FORMAT
        );
        photelTax.checkInDateTo = this.$options.filters.formatDate(
          addDays(new Date(), 7),
          DATE_TIME_FORMAT.API_DATE_FORMAT
        );
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_TAX_SETUP,
          "error in setStayPeriod",
          err.toString(),
          "setStayPeriod",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onChangeDate(pDateList) {
      try {
        if (BaseConfiguration.isDebug) console.log("onChangeDate");
        //  console.error(pDateList)
        //    this.fromDate=pDateList[0]._d;

        if (pDateList) {
          this.hotelTax.checkInDateFrom = this.$options.filters.formatDate(
            pDateList[0]._d,
            DATE_TIME_FORMAT.API_DATE_FORMAT
          );
          this.hotelTax.checkInDateTo = this.$options.filters.formatDate(
            pDateList[1]._d,
            DATE_TIME_FORMAT.API_DATE_FORMAT
          );
        }
        //  this.toDate=pDateList[1]._d;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_TAX_SETUP,
          "error in onChangeDate",
          err.toString(),
          "onChangeDate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    setHotelTax(pSelectedTax) {
      try {
        if (BaseConfiguration.isDebug) console.log("setHotelTax");
        // this.hotelTax = {
        //   id: pSelectedTax.id,
        //   taxCode: pSelectedTax.taxcode,
        //   taxDesc: pSelectedTax.taxdesc,
        //   roomTypes: pSelectedTax.roomtypes,
        //   paxType: pSelectedTax.paxtype,
        //   checkInDateFrom: pSelectedTax.checkindateFrom,
        //   checkInDateTo: pSelectedTax.checkindateTo,
        //   country: this.hotelTax.country,
        //   taxType: this.lsTaxTypes.find(
        //     (tax) => tax.value == pSelectedTax.taxtype
        //   ),
        //   taxCurrency: { code: pSelectedTax.taxCurrency },
        //   taxValue: pSelectedTax.taxValue,
        //   taxMode: pSelectedTax.taxmode,
        // };
        // this.hotelTax.country = null;
        if (pSelectedTax) {
          this.hotelTax = {
            id: pSelectedTax.id,
            taxCode: pSelectedTax.taxcode,
            taxDesc: pSelectedTax.taxdesc,
            roomTypes: pSelectedTax.roomtypes,
            paxType: pSelectedTax.paxtype,
            checkInDateFrom: pSelectedTax.checkindateFrom,
            checkInDateTo: pSelectedTax.checkindateTo,
            country: this.hotelTax.country,
            taxType: this.lsTaxTypes.find(
              (tax) => tax.value == pSelectedTax.taxtype
            ),
            taxCurrency: pSelectedTax.taxCurrency
              ? { code: pSelectedTax.taxCurrency }
              : null,
            taxValue: pSelectedTax.taxValue,
            taxMode: pSelectedTax.taxmode,
            hotelCondition: pSelectedTax.hotelCondition,
            isActive: pSelectedTax.isactive,
          };

          if (
            this.roomTypesRes &&
            this.roomTypesRes.length &&
            pSelectedTax.roomtypes &&
            pSelectedTax.roomtypes.length
          ) {
            this.roomTypesRes = this.roomTypesRes.filter(
              (roomType) => !pSelectedTax.roomtypes.includes(roomType)
            );
            this.roomTypesRes = [
              ...pSelectedTax.roomtypes,
              ...this.roomTypesRes,
            ];
            this.lsAllRoomTypes = cloneDeep(this.roomTypesRes);
          }

          if (
            !this.isHotelTax &&
            this.lsAllHotels &&
            this.lsAllHotels.length &&
            pSelectedTax.taxSetupHotels.length
          ) {
            let selectedHotels = pSelectedTax.taxSetupHotels.map(
              (hotel) => hotel.hotelid
            );
            this.hotelTax.hotelId = this.lsAllHotels.filter((hotelTax) =>
              selectedHotels.includes(hotelTax.hotelid)
            );
            this.isMultipleHotel = true;
          } else if (
            pSelectedTax.taxSetupHotels.length == 0 &&
            !this.isHotelTax
          ) {
            this.hotelTax.hotelId = [
              {
                hotelName: DEFAULT_DROPDOWN_STATUS.ALL,
                hotelid: DEFAULT_DROPDOWN_STATUS.ALL,
              },
            ];
            this.isMultipleHotel = false;
          }
        } else throw "not a valid tax";
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_TAX_SETUP,
          "error in setHotelTax",
          err.toString(),
          "setHotelTax",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    async initData() {
      try {
        if (BaseConfiguration.isDebug) console.log("initData");

        this.lsAllRoomTypes = await this.getRoomTypes();
        this.roomTypesRes = cloneDeep(this.lsAllRoomTypes);

        this.lsTaxTypes = this.getTaxTypes();

        this.lsGuestTypes = this.getGuestTypes();
        if (!this.isHotelTax && !this.lsAllHotels) {
          let hotelsList = await this.getAllHotels();
          if (hotelsList && hotelsList.length) this.SET_ALL_HOTELS(hotelsList);
        }

        if (this.selectedTax) {
          this.setHotelTax(cloneDeep(this.selectedTax));
        } else {
          this.setStayPeriod(this.hotelTax);
 
         
        }

        if(!this.hotelTax.taxCurrency && !this.isCountryTax)
        {
           this.hotelTax.taxCurrency = this.hotelObj
            ? { code: this.hotelObj.currency }
            : null;
        }
      else if(!this.hotelTax.taxCurrency && this.isCountryTax && this.selectedTax)
      {

       
         this.hotelTax.taxCurrency = this.allCurrencyList.find(curr=>curr.countryCode ==this.selectedTax.country)
      }
        

       
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_TAX_SETUP,
          "error in initData",
          err.toString(),
          "initData",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
  },

  async created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");
      await this.initData();
      this.isLoading = false;
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.C_HOTEL_TAX_SETUP,
        "error in created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
};
</script>

<style scoped>
.align-curr {
  margin-top: 22px;
}
.types {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.information {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.bed-type {
  margin-top: 15px;
  margin-bottom: 0;
}

.activeText {
  color: #03a9f4;
}
</style>
